import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
    selector: 'ca-form-validation-error-presenter',
    templateUrl: './form-validation-error-presenter.component.html',
    styleUrls: ['./form-validation-error-presenter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormValidationErrorPresenterComponent {
    @Input() validationErrors?: ValidationErrors;
}
